import { Link } from "@tanstack/react-router";
import { format } from "date-fns";
import { Minus, Plus } from "lucide-react";
import { useState } from "react";
import { ReactComponent as AISnippet } from "assets/img/icons/sidebar/ai-snippet.svg";
import { Spinner } from "components/elements";
import { trpc } from "lib/trpc";

export const NewsSidebar = () => {
    const {
        data,
        isPending: isLoading,
        isError,
    } = trpc.digest.getSitewideSummaries.useQuery({
        limit: 1,
    });

    if (isLoading) {
        return (
            <div className="text-center text-sm text-gray-500">
                <Spinner className="mx-auto" />
            </div>
        );
    }

    if (isError || !data?.summaries?.length) {
        return <div className="text-center text-sm text-red-500">No news available.</div>;
    }

    return (
        <>
            <div className="mb-6 rounded-2xl border border-[#c8c8c8] bg-white p-4 shadow-none">
                {/* Header */}
                <div className="mb-6 flex items-center gap-2">
                    <span className="text-blue-600">
                        <AISnippet />
                    </span>
                    <h2 className="font-sans text-xl font-bold leading-[24px] text-[#424242]">
                        Snippet of today´s AI
                    </h2>
                </div>

                {/*JSON.stringify(data.summaries)*/}
                {
                    <div className="flex flex-col gap-6 rounded-none border-t border-gray-200 bg-transparent pt-6">
                        {data.summaries.slice(0, 3).map((summary) => (
                            <Link
                                key={summary.id}
                                to="/digest/$id"
                                params={{ id: String(summary.id) }}
                                className="flex items-start gap-3 rounded-lg transition hover:bg-gray-50"
                            >
                                {/* Text content */}
                                <div className="flex flex-1 flex-col">
                                    <h3 className="font-sans text-[14px] font-semibold leading-normal text-[#424242]">
                                        {summary.title}
                                    </h3>
                                    <p className="mb-1.5 font-sans text-sm font-light leading-normal text-[#707070]">
                                        {summary.summary ||
                                            summary.content
                                                ?.replace(/<[^>]+>/g, "")
                                                ?.slice(0, 90) ||
                                            ""}
                                    </p>
                                </div>
                            </Link>
                        ))}
                    </div>
                }
            </div>
        </>
    );
};
